import { render, staticRenderFns } from "./ElementBadge.vue?vue&type=template&id=c88a6798&"
import script from "./ElementBadge.vue?vue&type=script&lang=ts&"
export * from "./ElementBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ElementBadge.vue?vue&type=style&index=0&id=c88a6798&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports